// =============================================================================
// src/features/analytics/analytics-insights-nav-markup.ts - Navegacao entre
// EDICOES do Resumo de IA (prev/next + rotulo data/tipo). Fica FORA do host
// re-renderizavel (#analyticsInsightDocHost) — os bindings sobrevivem a troca
// de edicao. Some por completo ('' ) no fallback estatico: digest identico ao
// de antes da integracao viva. prev = edicao mais ANTIGA, next = mais RECENTE
// (lista desc); pontas nascem disabled.
// =============================================================================

import {
  analyticsInsightActiveEditionRef,
  analyticsInsightAdjacentEditionRef,
  analyticsInsightsLiveActive,
} from './analytics-insights-live-store';
import type { AnalyticsInsightDocKind } from './analytics-insights-types';

/** '2026-07-27' -> '27/07/2026' por split de string — NUNCA new Date()
 * (determinismo do repo + meia-noite UTC viraria vespera no fuso de Manaus). */
export function analyticsInsightEditionDateLabel(isoEditionDate: string): string {
  const [yearPart, monthPart, dayPart] = isoEditionDate.split('-');
  /* v8 ignore next -- split devolve >=1 parte, yearPart nunca e undefined; ?? e defensivo (noUncheckedIndexedAccess) */
  return `${dayPart ?? '??'}/${monthPart ?? '??'}/${yearPart ?? '????'}`;
}

export function analyticsInsightDocKindLabel(docKind: AnalyticsInsightDocKind): string {
  return docKind === 'nota_de_deriva' ? 'Nota de deriva' : 'Edição completa';
}

/** Miolo do rotulo central (o controller o re-injeta a cada troca). */
export function analyticsInsightNavLabelMarkup(): string {
  const activeRef = analyticsInsightActiveEditionRef();
  if (activeRef === null) return '';
  return `Edição de ${analyticsInsightEditionDateLabel(activeRef.editionDate)}
    <em class="u-analytics-insight-kind">${analyticsInsightDocKindLabel(activeRef.docKind)}</em>`;
}

/** Nav completa; '' quando nao ha edicoes vivas (fallback estatico total). */
export function buildAnalyticsInsightNavMarkup(): string {
  if (!analyticsInsightsLiveActive()) return '';
  const prevDisabled = analyticsInsightAdjacentEditionRef('prev') === null ? ' disabled' : '';
  const nextDisabled = analyticsInsightAdjacentEditionRef('next') === null ? ' disabled' : '';
  return `<nav class="u-analytics-insight-nav" aria-label="Navegação de edições">
    <button type="button" class="u-analytics-insight-nav-btn" data-analytics-insight-nav="prev" aria-label="Edição anterior"${prevDisabled}><i class="ti ti-chevron-left"></i></button>
    <span class="u-analytics-insight-nav-label" data-analytics-insight-nav-label aria-live="polite">${analyticsInsightNavLabelMarkup()}</span>
    <button type="button" class="u-analytics-insight-nav-btn" data-analytics-insight-nav="next" aria-label="Edição mais recente"${nextDisabled}><i class="ti ti-chevron-right"></i></button>
  </nav>`;
}
